import * as angular from 'angular';
import { ngStorage } from 'ngstorage';
import { IPaginationFilter } from '../../../../../app.common/modules/common/models';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { BundleTypeEnum, IBundleListItem } from '../../models/models';
import { BundlesService } from '../../services/bundles.service';

class BundleListComponent {
    public static $inject = [
        '$localStorage',
        'notificationService',
        'bundlesService'
    ];

    public waiting = false;
    public countryID: number;
    public total: number;
    public bundleList: IBundleListItem[] = [];
    public dateFormat = 'dd/MM/yyyy';
    public bundleTypeEnum = BundleTypeEnum;

    constructor(
        private $localStorage: ngStorage.StorageService,
        private notificationService: NotificationService,
        private bundlesService: BundlesService
    ) {
    }

    public async $onInit() {
        this.countryID = this.$localStorage.retailerAuthorizationData.countryID;
        await this.loadData();
    }

    public async loadData() {
        if (this.waiting || this.bundleList && this.bundleList.length >= this.total) {
            return;
        }
        this.waiting = true;
        this.notificationService.showWaitingMessage();

        const filter: IPaginationFilter = {
            limit: 10,
            offset: this.bundleList ? this.bundleList.length : 0,
            sortOrder: '1',
            sortColumn: 'ID'
        };

        try {
            const data = await this.bundlesService.getBundleList(filter);
            this.total = data.Total;
            this.bundleList = [...this.bundleList, ...data.Items];
            this.waiting = false;
            this.notificationService.clearAll();
        } catch (error) {
            this.waiting = false;
            this.notificationService.showErrorMessage(error);
        }
    }

    public getLogoImage(logoID: number): string {
        return this.bundlesService.getLogoImageUrl(logoID, 240, 120);
    }

}

angular.module('naut').component('bundleListComponent', {
    template: require('./bundle-list.component.html'),
    controller: BundleListComponent,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/bundles/components/bundle-list/bundle-list.component.ts